import ConnectedToggle from "components/screener/shared/ConnectedToggle";

export default function IsBrazilianDepositaryReceipt() {
  return (
    <div className="space-y-2">
      <h3 className="font-aeonik text-base font-bold tracking-wide text-zinc-500">BDRs</h3>

      <div className="flex items-center justify-between">
        <span className="flex font-aeonik text-sm font-normal italic tracking-wider text-slate-400">
          Filtre por Ações que são BDRs
        </span>

        <ConnectedToggle label="BDRs" attribute="isBrazilianDepositaryReceipt" value={true} />
      </div>
    </div>
  );
}
